module.exports = __webpack_public_path__ + "img/fail.a4d5c2b5.png";